/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "billivoRegister",
            "endpoint": "https://cgp1adnep0.execute-api.eu-west-1.amazonaws.com/demo",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:5b106faa-7010-45d6-a3a9-64cb92fec63a",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_vNwrNNLQm",
    "aws_user_pools_web_client_id": "49q3a1pj1nkd4ujjrl9u02emg6",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
